<template>
  <div class="app-body">
    <el-form :inline="true" class="query-form" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item label="发票号：">
        <el-input v-model="dataForm.receiptCode" size="mini" placeholder="企业名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="客户：">
        <el-input v-model="dataForm.customerName" size="mini" placeholder="客户名" clearable></el-input>
      </el-form-item>
      <el-form-item label="税号：">
        <el-input v-model="dataForm.taxCode" size="mini" placeholder="税号" clearable></el-input>
      </el-form-item>
      <el-form-item label="银行：">
        <el-input v-model="dataForm.bank" size="mini" placeholder="银行" clearable></el-input>
      </el-form-item>
      <el-form-item label="银行账号：">
        <el-input v-model="dataForm.accountCode" size="mini" placeholder="银行账号" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="getDataList()" size="mini" type="primary">{{ $t('query') }}</el-button>
      </el-form-item>
    </el-form>
    <div class="table-bar" style="justify-content: flex-start;margin-bottom: 0;">
      <el-button class="bar-item" v-if="$hasPermission('trade:receiptlog:save')" size="mini" type="warning"
                 @click="showCreateInnerBoxDialog()">
        开票申请
      </el-button>
      <el-button class="bar-item" type="primary" size="mini"
                 @click="$export('/erp/box/detail/export/inner-sell',dataForm,null,'v2')">导出EXCEL
      </el-button>
      <el-button
          icon="el-icon-plus"
          v-if="$hasPermission('send:batch')"
          type="primary"
          @click="showOrderSendImportDialog"
          size="mini">销售开票批量导入
      </el-button>
      <!--      <FileLink  class="bar-item" file-url="" file-type="back" type="primary" :params="dataForm">导出EXCEL</FileLink>-->
    </div>
    <SweetTable url="/box/form/page" delete-url="/box/form" ref="table" :query-form="dataForm">
      <el-table-column prop="receiptCode" label="发票号" header-align="center" align="center"></el-table-column>
      <el-table-column prop="customerName" label="客户名称" header-align="center" align="center"></el-table-column>
      <el-table-column prop="taxCode" label="税号" header-align="center" align="center"></el-table-column>
      <el-table-column prop="bank" label="银行" header-align="center" align="center"></el-table-column>
      <el-table-column prop="accountCode" label="银行账号" header-align="center" align="center"></el-table-column>
      <el-table-column prop="totalAmount" label="开票金额" header-align="center" align="center"
                       width="160"></el-table-column>
      <el-table-column prop="shipDate" label="发货日期" header-align="center" align="center"
                       width="120"></el-table-column>
      <el-table-column prop="creatorName" label="制单人" header-align="center" align="center"
                       width="120"></el-table-column>
      <el-table-column prop="createDate" label="制单时间" header-align="center" align="center"
                       width="160"></el-table-column>
      <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="200">
        <template slot-scope="scope">
          <el-button v-if="$hasPermission('box:receipt')&&!scope.row.receiptCode" type="text" size="small"
                     @click="showReceiptDialog(scope.row)">发票号
          </el-button>
<!--          <el-button v-if="$hasPermission('trade:receiptlog:update')&&!scope.row.receiptCode" type="text" size="small"-->
<!--                     @click="addOrUpdateHandle(scope.row)">{{ $t('update') }}-->
<!--          </el-button>-->
<!--          -->
          <el-button v-if="$hasPermission('trade:receiptlog:delete')&&!scope.row.receiptCode" type="text" size="small"
                     @click="doDel(scope.row)">{{ $t('delete') }}
          </el-button>
          <el-button type="text" size="small"
                     @click="showDetailDialog(scope.row)">查看明细
          </el-button>
          <el-button type="text" size="small" v-if="$hasPermission('erp:sell:code:edit')&&scope.row.receiptCode"
                     @click="showEditCodeDialog(scope.row)">修改发票号
          </el-button>
        </template>
      </el-table-column>
    </SweetTable>
    <detail-dialog ref="DetailDialog"></detail-dialog>
    <receipt-dialog ref="ReceiptDialog"></receipt-dialog>
    <EditCodeDialog ref="EditCodeDialog" @change="getDataList()"></EditCodeDialog>
    <CreateInnerBox ref="CreateInnerBox" @change="getDataList"></CreateInnerBox>
    <OrderSendImportDialog ref="OrderSendImportDialog" send-type="sell" @changed="getDataList"></OrderSendImportDialog>
  </div>
</template>

<script>
import EditCodeDialog from '@/views/modules/erp/box/inner/edit-code-dialog.vue'
import SweetTable from '@/mixins/SweetTable'
import ReceiptDialog from '@/views/modules/box-form/receipt-dialog'
import mixinViewModule from '@/mixins/view-module'
import DetailDialog from './detail-dialog'
import FileLink from '@/components/FileLink'
import CreateInnerBox from '@/views/modules/erp/box/create-inner-box/index.vue'
import OrderSendImportDialog from '@/views/modules/erp/box/order-send-import-dialog.vue'

export default {
  mixins: [mixinViewModule, SweetTable],
  components: {
    DetailDialog, ReceiptDialog, EditCodeDialog, FileLink, CreateInnerBox, OrderSendImportDialog
  },
  data () {
    return {
      visible: false,
      mixinViewModuleOptions: {
        getDataListURL: '/box/form/page',
        getDataListIsPage: true,
        deleteURL: '/box/form',
        deleteIsBatch: false,
      },
      dataForm: {
        receiptCode: '',
        customerName: '',
        taxCode: '',
        address: '',
        bank: '',
        accountCode: '',
        formType: 'sell'
      }
    }
  },

  methods: {
    showOrderSendImportDialog () {
      this.$refs.OrderSendImportDialog.init()
    },
    showCreateInnerBoxDialog () {
      this.$refs.CreateInnerBox.init()
    },
    showEditCodeDialog (row) {
      this.$refs.EditCodeDialog.init({ id: row.id, receiptCode: row.receiptCode })
    },
    doDel (row) {
      this.$confirm(`是否删除开票记录?`).then(() => {
        this.$api2.delete(`/erp/box/${row.id}`).then(res => {
          this.$message.success('删除成功')
          this.getDataList()
        })
      })
    },
    showReceiptDialog (row) {
      this.$refs.ReceiptDialog.init(row.id)
    },
    showDetailDialog (row) {
      this.$refs.DetailDialog.init(row.id)
    },
    addOrUpdateHandle (row) {
      let path = `/erp/box/save?type=sell&id=`
      if (row) {
        path += row.id
      }
      this.$router.push(path)
    }
  }
}
</script>
